import React, { useEffect, useRef, useState } from 'react';
import '../CSS/Global.css';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import Sidebar from './SideBar';
import { useSidebar } from '../SidebarContext';
import Header from './Header';

function convertToWords(num) {
    num = Number(num);
    if (isNaN(num) || num <= 0) return '';
    const a = [
        '', 'One', 'Two', 'Three', 'Four', 'Five', 'Six',
        'Seven', 'Eight', 'Nine', 'Ten', 'Eleven', 'Twelve',
        'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen',
        'Eighteen', 'Nineteen'
    ];
    const b = ['', '', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

    const numberToWords = (n) => {
        if (n < 20) return a[n];
        if (n < 100) return b[Math.floor(n / 10)] + (n % 10 ? " " + a[n % 10] : "");
        if (n < 1000) return a[Math.floor(n / 100)] + " Hundred" + (n % 100 ? " and " + numberToWords(n % 100) : "");
        if (n < 100000) return numberToWords(Math.floor(n / 1000)) + " Thousand" + (n % 1000 ? " " + numberToWords(n % 1000) : "");
        if (n < 10000000) return numberToWords(Math.floor(n / 100000)) + " Lakh" + (n % 100000 ? " " + numberToWords(n % 100000) : "");
        return numberToWords(Math.floor(n / 10000000)) + " Crore" + (n % 10000000 ? " " + numberToWords(n % 10000000) : "");
    };

    return numberToWords(Number(num));
}


const CommercialPropertyForm = () => {
    const { isSidebarOpen } = useSidebar();
    const [amenities, setAmenities] = useState([]);
    const [category, setCategory] = useState([]);
    const [selectedAmenities, setSelectedAmenities] = useState([]);
    const [locationAdvantages, setLocationAdvantages] = useState([]);
    const [selectedLocationAdvantages, setSelectedLocationAdvantages] = useState([]);
    const [availabilityStatus, setAvailabilityStatus] = useState("Ready to Move");
    const fileInputRef = useRef(null);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [dragging, setDragging] = useState(false);
    const [load, setLoad] = useState(true)
    const [watersupply, setWaterSupply] = useState([]);
    const [selectedWaterSupply, setSelectedWaterSupply] = useState([]);
    const [security, setSecurity] = useState([]);
    const [selectedsecurity, setSelectedSecurity] = useState([]);

    const [data, setData] = useState({
        building_name: "",
        address: "",
        city: "",
        floorPlan: "",
        flatType: "1BHK",
        carpetArea: [{ carpetArea: "", price: "" }],
        buildupArea: "",
        totalFloors: "",
        floorLevel: "",
        bedrooms: "",
        jodi1: "",
        jodi2: "",
        bathrooms: "",
        balconies: "",
        availability: "",
        ageOfBuilding: "",
        possessionTill: "",
        ownership: "",
        facing: "",
        maintenance: "",
        parking: "",
        securityDeposit: "",
        virtualTour: "",
        furnishStatus: "",
        category: "",
        developerName: '',
        developerDescription: '',
        propertyDescription: '',
        dev_logo: '',

        // 1BHK-specific fields
        bhk1CarpetAreas: [{ value: "", showMinus: false }],
        bhk1BuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
        bhk1SuperBuiltUpAreas: [{ value: "", showMinus: false }],
        bhk1ExpectedPrices: [{ value: '' }],
        bhk1Bedrooms: '',
        bhk1BedroomsJodi1: '',
        bhk1BedroomsJodi2: '',
        bhk1Balconies: '',
        bhk1Bathrooms: '',
        bhk1FurnishStatus: '',
        bhk1ConditionOfFlat: '',
        bhk1MonthlyMaintenance: '',
        bhk1PriceAllInclusive: '',
        bhk1PriceNegotiable: '',
        bhk1PreferredCashType: [],
        bhk1LoanFacility: '',
        bhk1DocumentsAvailable: '',
        bhk1FloorPlan: '',
        extra1: "",
        extra2: ""
    })
    const isLoggedIn = JSON.parse(localStorage.getItem("2xgxgshdugyywerw12gh")) || "";

    const navigate = useNavigate();
    const [previews, setPreviews] = useState({
        dev_logo: null,
        bhk4FloorPlan: null,
        bhk3FloorPlan: null,
        bhk2FloorPlan: null,
        bhk1FloorPlan: null,
        rkFloorPlan: null,
    });

    const [errors, setErrors] = useState({
        dev_logo: '',
        bhk4FloorPlan: '',
        bhk3FloorPlan: '',
        bhk2FloorPlan: '',
        bhk1FloorPlan: '',
        rkFloorPlan: '',
    });




    const handleAmenityChange = (event) => {
        const { value } = event.target;
        if (selectedAmenities.includes(value)) {
            setSelectedAmenities(selectedAmenities.filter((item) => item !== value));
        } else {
            setSelectedAmenities([...selectedAmenities, value]);
        }
    };

    const handleLocationAdvantageChange = (event) => {
        const { value } = event.target;
        if (selectedLocationAdvantages.includes(value)) {
            setSelectedLocationAdvantages(
                selectedLocationAdvantages.filter((item) => item !== value)
            );
        } else {
            setSelectedLocationAdvantages([...selectedLocationAdvantages, value]);
        }
    };

    const toggleWaterSupply = (advantage) => {
        if (selectedWaterSupply.includes(advantage)) {
            setSelectedWaterSupply(
                selectedWaterSupply.filter((item) => item !== advantage)
            );
        } else {
            setSelectedWaterSupply([...selectedWaterSupply, advantage]);
        }
    };

    const toggleSecurity = (advantage) => {
        if (selectedsecurity.includes(advantage)) {
            setSelectedSecurity(
                selectedsecurity.filter((item) => item !== advantage)
            );
        } else {
            setSelectedSecurity([...selectedsecurity, advantage]);
        }
    };

    const [showCarpet, setShowCarpet] = useState(false);
    const [showSuperBuiltUp, setShowSuperBuiltUp] = useState(false);
    const [viewBedroomsMore, setViewBedroomsMore] = useState(false);
    const [viewBalconiesMore, setViewBalconiesMore] = useState(false);
    const [viewBathroomsMore, setViewBathroomsMore] = useState(false);
    const [openIndex, setOpenIndex] = useState(null);
    const [superBuiltUpAreas, setSuperBuiltUpAreas] = useState([{ value: "", showMinus: false }]);

    const handleToggle = (index) => {
        setOpenIndex(openIndex === index ? null : index);
    };

    const maxFiles = 20; // Max number of files
    const maxSize = 20 * 1024 * 1024; // 20MB size limit in bytes

    const handleBrowseClick = (event) => {
        event.preventDefault();
        fileInputRef.current.click(); // Trigger the hidden file input
    };

    const formatFileSize = (size) => {
        if (size < 1024) return `${size} B`;
        if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
        return `${(size / (1024 * 1024)).toFixed(2)} MB`;
    };

    const flatTypeFields = {
        "1BHK": [
            "bhk1CarpetAreas", "bhk1ExpectedPrices", "bhk1Bedrooms", "bhk1Balconies", "bhk1Bathrooms",
            "bhk1FurnishStatus", "bhk1ConditionOfFlat", "bhk1MonthlyMaintenance", "bhk1PriceAllInclusive",
            "bhk1PriceNegotiable", "bhk1PreferredCashType",
        ],
    };


    const validateFields = () => true;



    const addInput = () => {
        setData((prevData) => ({
            ...prevData,
            carpetArea: [...prevData.carpetArea, { carpetArea: "", price: "" }],
        }));
    };

    const deleteInput = (index) => {
        setData((prevData) => ({
            ...prevData,
            carpetArea: prevData.carpetArea.filter((_, i) => i !== index),
        }));
    };


    const handleDynamicChange = (e, fieldName, index, fieldKey = "value") => {
        const { value } = e.target;

        setData((prevState) => {
            const updatedField = Array.isArray(prevState[fieldName]) // Ensure it's an array
                ? [...prevState[fieldName]]
                : []; // If not, initialize it as an empty array

            // Update the specific field (value or expectedPrice)
            updatedField[index] = {
                ...updatedField[index],
                [fieldKey]: value,
            };

            return {
                ...prevState,
                [fieldName]: updatedField,
            };
        });
    };

    const handleAddField = (fieldName) => {
        setData((prevState) => ({
            ...prevState,
            [fieldName]: [
                ...prevState[fieldName],
                { value: "", expectedPrice: "", showMinus: false },
            ],
        }));
    };

    const handleRemoveField = (fieldName, index) => {
        setData((prevState) => {
            const updatedField = [...prevState[fieldName]];
            updatedField.splice(index, 1); // Remove the field at the given index
            return {
                ...prevState,
                [fieldName]: updatedField,
            };
        });
    };


    const handleEnterPress = (e, type) => {
        if (e.key === "Enter") {
            const value = e.target.value;
            if (Number(value) >= 5) {
                setData((prev) => ({
                    ...prev,
                    [type]: String(value),
                }));
            }
        }
    };

    const handleFileChange = (event) => {
        const files = Array.from(event.target.files);

        const validFiles = files.filter(file =>
            ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'].includes(file.type)
        );

        const duplicateFiles = validFiles.filter(file =>
            uploadedFiles.some(existingFile => existingFile.name === file.name)
        );

        if (duplicateFiles.length > 0) {
            toast.error('You cannot upload duplicate images.');
            return;
        }

        if (uploadedFiles.length + validFiles.length > maxFiles) {
            toast.error(`You can upload a maximum of ${maxFiles} images.`);
            return;
        }

        setUploadedFiles(prevFiles => [...prevFiles, ...validFiles]); // store plain File objects
    };

    const handleDeleteFile = (index) => {
        setUploadedFiles(prevFiles => prevFiles.filter((_, i) => i !== index));
    };

    const handleDragOver = (event) => {
        event.preventDefault();
        setDragging(true);
    };

    const toggleAmenity = (amenity) => {
        if (selectedAmenities.includes(amenity)) {
            setSelectedAmenities(selectedAmenities.filter((item) => item !== amenity));
        } else {
            setSelectedAmenities([...selectedAmenities, amenity]);
        }
    };

    const toggleLocationAdvantage = (advantage) => {
        if (selectedLocationAdvantages.includes(advantage)) {
            setSelectedLocationAdvantages(
                selectedLocationAdvantages.filter((item) => item !== advantage)
            );
        } else {
            setSelectedLocationAdvantages([...selectedLocationAdvantages, advantage]);
        }
    };

    const handleDragLeave = () => setDragging(false);

    const handleDrop = (event) => {
        event.preventDefault();
        setDragging(false);

        const files = Array.from(event.dataTransfer.files);

        const validFiles = files.filter(file =>
            file.size <= maxSize &&
            ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'].includes(file.type)
        );

        const duplicateFiles = validFiles.filter(file =>
            uploadedFiles.some(existingFile => existingFile.name === file.name)
        );

        if (duplicateFiles.length > 0) {
            toast.error('You cannot upload duplicate images.');
            return;
        }

        if (uploadedFiles.length + validFiles.length > maxFiles) {
            toast.error(`You can upload a maximum of ${maxFiles} images.`);
            return;
        }

        setUploadedFiles(prevFiles => [...prevFiles, ...validFiles]);
    };

    const handleRemoveTag = (index, type) => {
        const updatedList = type === 'amenities'
            ? amenities.split(',').filter((_, i) => i !== index).join(',')
            : locationAdvantages.split(',').filter((_, i) => i !== index).join(',');

        type === 'amenities' ? setAmenities(updatedList) : setLocationAdvantages(updatedList);
    };
    // 4BHK section
    const render1BHKSection = () => {
        return (

            <div className='render-commercial'>
                {/* Built-up Area and Expected Price */}
                <div>
                    <label>Carpet Area (Sq.ft) & Expected Price</label>
                    {data.bhk1BuiltUpAreas.map((area, index) => (
                        <>
                            <div key={index} className="carpet-add-remove" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                <div style={{ flex: 1 }}>
                                    <input
                                        type="text"
                                        placeholder="Enter Carpet Area"
                                        value={area.value}
                                        onChange={(e) => handleDynamicChange(e, "bhk1BuiltUpAreas", index, "value")}

                                    />
                                </div>
                                <div style={{ flex: 1 }}>
                                    <input
                                        type="text"
                                        placeholder="Enter Expected Price"
                                        value={
                                            area.expectedPrice && !isNaN(area.expectedPrice)
                                                ? Number(area.expectedPrice).toLocaleString("en-IN")
                                                : area.expectedPrice || ""
                                        }
                                        onChange={(e) => {
                                            const plainNumber = e.target.value.replace(/,/g, '');
                                            handleDynamicChange({ target: { value: plainNumber } }, "bhk1BuiltUpAreas", index, "expectedPrice");
                                        }}

                                    />
                                    <small style={{ fontSize: "12px", color: "#007bff", fontWeight: "600" }}>
                                        {area.expectedPrice ? `(${convertToWords(area.expectedPrice)} only)` : ""}
                                    </small>
                                </div>
                                <div style={{ marginTop: 10 }}>
                                    {index === data.bhk1BuiltUpAreas.length - 1 ? (
                                        <i className="fa-solid fa-plus" onClick={() => handleAddField("bhk1BuiltUpAreas")} style={{ cursor: 'pointer' }}></i>
                                    ) : (
                                        <i className="fa-solid fa-minus" onClick={() => handleRemoveField("bhk1BuiltUpAreas", index)} style={{ cursor: 'pointer' }}></i>
                                    )}
                                </div>
                            </div>

                        </>
                    ))}
                </div>



                {/* Furnish Status */}
                <div>
                    <label>Furnish Status</label>
                    <div className="radio-group">
                        {["Furnished", "Unfurnished", "Semi-furnished"].map((status) => (
                            <div className="radio-option" key={status}>
                                <input
                                    type="radio"
                                    name="bhk1FurnishStatus"
                                    value={status}
                                    id={`furnish-${status}`}
                                    checked={data.bhk1FurnishStatus === status}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor={`furnish-${status}`}>{status}</label>
                            </div>
                        ))}
                    </div>
                    {errors.bhk1FurnishStatus && <span className="error">This field is required*</span>}
                </div>

                {/* Condition of Flat */}
                <div>
                    <label>Condition of Flat</label>
                    <input
                        type="text"
                        name="bhk1ConditionOfFlat"
                        value={data.bhk1ConditionOfFlat}
                        onChange={handleInputChange}
                        placeholder="Enter condition of flat"
                    />
                    {errors.bhk1ConditionOfFlat && <span className="error">This field is required*</span>}
                </div>

                {/* Monthly Maintenance */}
                <div>
                    <label>Monthly Maintenance</label>
                    <input
                        type="text"
                        name="bhk1MonthlyMaintenance"
                        value={data.bhk1MonthlyMaintenance}
                        onChange={handleInputChange}
                        placeholder="Enter Monthly Maintenance"
                    />
                    {errors.bhk1MonthlyMaintenance && <span className="error">This field is required*</span>}
                </div>

                {/* Price All Inclusive */}
                <div>
                    <label>Price All Inclusive</label>
                    <div className="radio-group">
                        {["Yes", "No"].map((val) => (
                            <div className="radio-option" key={val}>
                                <input
                                    type="radio"
                                    name="bhk1PriceAllInclusive"
                                    value={val}
                                    id={`price-inclusive-${val}`}
                                    checked={data.bhk1PriceAllInclusive === val}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor={`price-inclusive-${val}`}>{val}</label>
                            </div>
                        ))}
                    </div>
                    {errors.bhk1PriceAllInclusive && <span className="error">This field is required*</span>}
                </div>

                {/* Price Negotiable */}
                <div>
                    <label>Price Negotiable</label>
                    <div className="radio-group">
                        {["Yes", "No"].map((val) => (
                            <div className="radio-option" key={val}>
                                <input
                                    type="radio"
                                    name="bhk1PriceNegotiable"
                                    value={val}
                                    id={`price-negotiable-${val}`}
                                    checked={data.bhk1PriceNegotiable === val}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor={`price-negotiable-${val}`}>{val}</label>
                            </div>
                        ))}
                    </div>
                    {errors.bhk1PriceNegotiable && <span className="error">This field is required*</span>}
                </div>

                {/* Preferred Cash Type */}
                <div>
                    <label>Preferred Cash Type</label>
                    <div className="checkbox-group">
                        {["Cash", "Cheque"].map((type) => (
                            <div className="checkbox-option" key={type}>
                                <input
                                    type="checkbox"
                                    name="bhk1PreferredCashType"
                                    value={type}
                                    id={`cash-type-${type}`}
                                    checked={data.bhk1PreferredCashType.includes(type)}
                                    onChange={handleInputChange}
                                />
                                <label htmlFor={`cash-type-${type}`}>{type}</label>
                            </div>
                        ))}
                    </div>
                    {errors.bhk1PreferredCashType && <span className="error">This field is required*</span>}
                </div>

                {/* Floor Plan Upload */}
                <div className="post-input">
                    <label>Floor plan</label>
                    <input
                        type="file"
                        name="bhk1FloorPlan"
                        accept="image/*"
                        onChange={handleInputChange}
                    />
                    {previews.bhk1FloorPlan && (
                        <div className="image-preview">
                            <img
                                src={previews.bhk1FloorPlan}
                                alt="BHK1 Floor Plan Preview"
                                style={{ maxWidth: "150px", marginTop: "10px" }}
                            />
                        </div>
                    )}
                    {errors.bhk1FloorPlan && <span className="error">{errors.bhk1FloorPlan}</span>}
                </div>
            </div>
        );
    };



    const handleInputChange = (e) => {
        const { name, value, type, checked, files } = e.target;

        const allowedFormats = ['image/jpeg', 'image/jpg', 'image/png', 'image/webp'];
        const maxImageSize = 1024 * 1024; // 1MB

        if (type === "file") {
            const file = files[0];
            if (file) {
                // Validate file format
                if (!allowedFormats.includes(file.type)) {
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        [name]: 'Invalid file format. Only JPG, JPEG, PNG, and WEBP are allowed.',
                    }));
                    return;
                }

                // Validate file size
                if (file.size > maxImageSize) {
                    setErrors((prevErrors) => ({
                        ...prevErrors,
                        [name]: 'File size should not exceed 1MB.',
                    }));
                    return;
                }

                // Set file preview
                const reader = new FileReader();
                reader.onloadend = () => {
                    setPreviews((prevPreviews) => ({
                        ...prevPreviews,
                        [name]: reader.result,
                    }));
                };
                reader.readAsDataURL(file);

                // Update state
                setData((prevState) => ({
                    ...prevState,
                    [name]: file,
                }));

                // Clear error if any
                if (errors[name]) {
                    setErrors((prevErrors) => {
                        const { [name]: removedError, ...rest } = prevErrors;
                        return rest;
                    });
                }
            }
        } else if (type === "checkbox") {
            const updatedArray = checked
                ? [...(data[name] || []), value]
                : (data[name] || []).filter((item) => item !== value);

            setData((prevState) => ({
                ...prevState,
                [name]: updatedArray,
            }));
        } else {
            setData((prevState) => ({
                ...prevState,
                [name]: value,
            }));
        }

        // Clear error for non-file inputs
        if (type !== "file" && errors[name]) {
            setErrors((prevErrors) => {
                const { [name]: removedError, ...rest } = prevErrors;
                return rest;
            });
        }
    };

    useEffect(() => {
        fetchAmenities();
        fetchLocationAdvantages();
        fetchCategory();
        fetchSecurityFeature();
        fetchWaterSupply();
    }, []);

    const fetchAmenities = async () => {
        try {
            const response = await fetch(`https://100real.xyz/amenities/all/${isLoggedIn.user_id}`);
            const result = await response.json();
            const activeAmenities = result.filter(amenity => amenity.status === 'active');
            setAmenities(activeAmenities.reverse() || []);
        } catch (error) {
            console.error("Error fetching amenities:", error);
        }
    };

    const fetchWaterSupply = async () => {
        try {
            const response = await fetch(`https://100real.xyz/water-supply/all/${isLoggedIn.user_id}`);
            const result = await response.json();
            const activeAmenities = result.filter(amenity => amenity.status === 'active');
            setWaterSupply(activeAmenities.reverse() || []);
        } catch (error) {
            console.error("Error fetching amenities:", error);
        }
    };

    const fetchSecurityFeature = async () => {
        try {
            const response = await fetch(`https://100real.xyz/security/all/${isLoggedIn.user_id}`);
            const result = await response.json();
            const activeAmenities = result.filter(amenity => amenity.status === 'active');
            setSecurity(activeAmenities.reverse() || []);
        } catch (error) {
            console.error("Error fetching amenities:", error);
        }
    };

    const fetchLocationAdvantages = async () => {
        try {
            const response = await fetch(`https://100real.xyz/location/all/${isLoggedIn.user_id}`);
            const result = await response.json();
            const activeAmenities = result.filter(amenity => amenity.status === 'active');
            setLocationAdvantages(activeAmenities.reverse() || []);
        } catch (error) {
            console.error("Error fetching location advantages:", error);
        }
    };

    const fetchCategory = async () => {
        try {
            const response = await axios.get(`https://100real.xyz/propertycategory/all/${isLoggedIn.user_id}`);
            const activeAmenities = response.data.filter(amenity => amenity.status === 'active');
            setCategory(activeAmenities.reverse());

        } catch (error) {
            console.error('Error fetching amenities:', error);
        }
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoad(false)
        // if (validateFields()) {
        const bhk1Details = {
            carpetAreas: data.bhk1CarpetAreas,
            builtUpAreas: data.bhk1BuiltUpAreas,
            superBuiltUpAreas: data.bhk1SuperBuiltUpAreas,
            bedrooms: data.bhk1Bedrooms,
            balconies: data.bhk1Balconies,
            bathrooms: data.bhk1Bathrooms,
            jodi1: data.bhk1BedroomsJodi1,
            jodi2: data.bhk1BedroomsJodi2,
            furnishStatus: data.bhk1FurnishStatus,
            conditionOfFlat: data.bhk1ConditionOfFlat,
            expectedPrice: data.bhk1ExpectedPrice,
            monthlyMaintenance: data.bhk1MonthlyMaintenance,
            priceAllInclusive: data.bhk1PriceAllInclusive,
            priceNegotiable: data.bhk1PriceNegotiable,
            preferredCashType: data.bhk1PreferredCashType,
            loanFacility: data.bhk1LoanFacility,
            documentsAvailable: data.bhk1DocumentsAvailable,
            floorPlan: data.bhk1FloorPlan,
        };
        const formDataPayload = new FormData();
        const flatTypeData = [
            {
                ...bhk1Details,
                floorPlan: data.bhk1FloorPlan ? data.bhk1FloorPlan.name : null,
            },
        ];

        formDataPayload.append("flatType", JSON.stringify(flatTypeData));
        formDataPayload.append("building_name", data.building_name);
        formDataPayload.append("address", data.address);
        formDataPayload.append("city", data.city);
        formDataPayload.append("user_id", isLoggedIn.user_id);
        formDataPayload.append("amenities", JSON.stringify(selectedAmenities));
        formDataPayload.append("totalFloors", data.totalFloors);
        formDataPayload.append("floorLevel", data.floorLevel);
        formDataPayload.append("availability", availabilityStatus);
        formDataPayload.append("ageOfBuilding", data.ageOfBuilding);
        formDataPayload.append("possessionTill", data.possessionTill);
        formDataPayload.append("under_construction", data.under_construction);
        formDataPayload.append("ownership", data.ownership);
        formDataPayload.append("facing", data.facing);
        formDataPayload.append("brokage", data.brokage);
        formDataPayload.append("parking", data.parking);
        formDataPayload.append("booking_amount", data.securityDeposit);
        formDataPayload.append("locationAdvantage", JSON.stringify(selectedLocationAdvantages));
        formDataPayload.append("water_supply", JSON.stringify(selectedWaterSupply));
        formDataPayload.append("security", JSON.stringify(selectedsecurity));
        formDataPayload.append("virtual_tour", data.virtualTour);
        formDataPayload.append("developer_name", data.developerName);
        formDataPayload.append("developer_description", data.developerDescription);
        formDataPayload.append("property_description", data.propertyDescription);

        if (data.floorPlan) {
            formDataPayload.append("floorPlan", data.floorPlan); // Match the backend field name
        }

        if (data.dev_logo) {
            formDataPayload.append("dev_logo", data.dev_logo); // Match the backend field name
        }



        uploadedFiles.forEach((image, index) => {
            formDataPayload.append(`formImages`, image); // Ensure formImages are appended correctly
        });
        if (data.bhk1FloorPlan) {
            formDataPayload.append("bhk1FloorPlan", data.bhk1FloorPlan, data.bhk1FloorPlan.name);
        }

        try {
            const response = await fetch("https://100real.xyz/commercial/add-property", {
                method: "POST",
                body: formDataPayload,
            });
            const result = await response.json();
            if (response.ok) {

                toast.success('Property Added successfully!');
                navigate(`/property-2`)
                setLoad(true);
                setData({
                    building_name: "",
                    address: "",
                    city: "",
                    floorPlan: "",
                    flatType: [],
                    carpetArea: [{ carpetArea: "", price: "" }],
                    buildupArea: "",
                    totalFloors: "",
                    floorLevel: "",
                    bedrooms: "",
                    bathrooms: "",
                    balconies: "",
                    availability: "",
                    ageOfBuilding: "",
                    possessionTill: "",
                    ownership: "",
                    facing: "",
                    maintenance: "",
                    parking: "",
                    securityDeposit: "",
                    virtualTour: "",
                    furnishStatus: "",
                    category: "",

                    // 1BHK-specific fields
                    bhk1CarpetAreas: [{ value: "", showMinus: false }],
                    bhk1BuiltUpAreas: [{ value: "", expectedPrice: "", showMinus: false }],
                    bhk1SuperBuiltUpAreas: [{ value: "", showMinus: false }],
                    bhk1ExpectedPrices: [{ value: '' }],
                    bhk1Bedrooms: '',
                    bhk1BedroomsJodi1: '',
                    bhk1BedroomsJodi2: '',
                    bhk1Balconies: '',
                    bhk1Bathrooms: '',
                    bhk1FurnishStatus: '',
                    bhk1ConditionOfFlat: '',
                    bhk1MonthlyMaintenance: '',
                    bhk1PriceAllInclusive: '',
                    bhk1PriceNegotiable: '',
                    bhk1PreferredCashType: [],
                    bhk1LoanFacility: '',
                    bhk1DocumentsAvailable: '',
                    bhk1FloorPlan: '',
                })
            } else {
                setLoad(true);
                toast.error(result.message);
            }
        } catch (error) {
            setLoad(true);
            toast.error(error);

        }
        // } else {
        //     setLoad(true);
        //     toast.error("Form has errors:", errors);

        // }
    };


    return (
        <>
            <Header />
            <Sidebar />
            <div className={`open-close ${isSidebarOpen ? 'open' : 'closed'}`}>
                <form className="property-form" onSubmit={handleSubmit}>
                    <div className="oms-header">
                        <h1 className="dashboard-title">Commercial Form</h1>
                        <Link to="/property-2" className="dashboard-p-form">
                            View Properties
                        </Link>
                    </div>
                    <div>
                        <label>Building/Project Name</label>
                        <input type="text" name="building_name" value={data.building_name} onChange={handleInputChange} placeholder="Enter Building/Project Name" />
                    </div>
                    <div>
                        <label>Address</label>
                        <input type="text" name="address" value={data.address} onChange={handleInputChange} placeholder="Enter Full Address" />
                    </div>
                    <div>
                        <label>City</label>
                        <input type="text" name="city" value={data.city} onChange={handleInputChange} placeholder="Enter City" />
                    </div>
                    <div className="location">
                        <div>
                            <label>Amenities</label>
                            <div className="button-group">
                                {amenities.map((amenity) => (
                                    <button
                                        type="button"
                                        key={amenity.id}
                                        className={`toggle-button ${selectedAmenities.includes(amenity.name) ? "selected" : ""
                                            }`}
                                        onClick={() => toggleAmenity(amenity.name)}
                                    >
                                        {amenity.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>

                    {render1BHKSection()}

                    <div>
                        <label>Total Number of Floors</label>
                        <input type="text" name="totalFloors" value={data.totalFloors} onChange={handleInputChange} placeholder="Enter Total Number of Floors" />
                    </div>
                    <div>
                        <label>Floor Number</label>
                        <input type="text" name="floorLevel" value={data.floorLevel} onChange={handleInputChange} placeholder="Enter Floor Number (e.g., 1, 2, etc.)" />
                    </div>
                    <div className="radio-group">
                        <label>Availability Status</label>
                        <input
                            type="radio"
                            id="availability-ready"
                            name="availability"
                            value="Ready to Move"
                            checked={availabilityStatus === "Ready to Move"}
                            onChange={() => setAvailabilityStatus("Ready to Move")}
                        />
                        <label htmlFor="availability-ready">Ready to Move</label>
                        <input
                            type="radio"
                            id="availability-under"
                            name="availability"
                            value="Under Construction"
                            checked={availabilityStatus === "Under Construction"}
                            onChange={() => setAvailabilityStatus("Under Construction")}
                        />
                        <label htmlFor="availability-under">Under Construction</label>
                    </div>
                    {availabilityStatus === "Ready to Move" ? (
                        <div className='margin-top-10px-oms-div'>
                            <label>Age of Building (years)</label>
                            <input type="text" name="ageOfBuilding" placeholder="Enter Age of Building" value={data.ageOfBuilding} onChange={handleInputChange} />
                        </div>
                    ) : (
                        <div className='margin-top-10px-oms-div'>
                            <label>Possession Till</label>
                            <input type="date" name="possessionTill" placeholder="Select Possession Date" value={data.possessionTill} onChange={handleInputChange} />
                        </div>
                    )}
                    <div className="radio-group">
                        <label>Ownership</label>
                        <input type="radio" id="ownership-freehold" name="ownership" value="freehold" onChange={handleInputChange} />
                        <label htmlFor="ownership-freehold">Freehold</label>
                        <input type="radio" id="ownership-leasehold" name="ownership" value="leasehold" onChange={handleInputChange} />
                        <label htmlFor="ownership-leasehold">Leasehold</label>
                        <input type="radio" id="ownership-SRA-Redevelopment" name="ownership" value="SRA-Redevelopment" onChange={handleInputChange} />
                        <label htmlFor="ownership-SRA-Redevelopment">SRA Redevelopment</label>
                        <input type="radio" id="ownership-Society-Redevelopment" name="ownership" value="Society-Redevelopment" onChange={handleInputChange} />
                        <label htmlFor="ownership-Society-Redevelopment">Society Redevelopment</label>
                        <input type="radio" id="ownership-MHADA-Redevelopment" name="ownership" value="MHADA-Redevelopment" onChange={handleInputChange} />
                        <label htmlFor="ownership-MHADA-Redevelopment">MHADA Redevelopment</label>
                        <input type="radio" id="ownership-BMC-Redevelopment" name="ownership" value="BMC-Redevelopment" onChange={handleInputChange} />
                        <label htmlFor="ownership-BMC-Redevelopment">BMC Redevelopment</label>
                    </div>
                    <div className="radio-group">
                        <label className='margin-top-10px-oms-div'>Facing Direction</label>
                        <input type="radio" id="facing-north" name="facing" value="north" onChange={handleInputChange} />
                        <label htmlFor="facing-north">North</label>
                        <input type="radio" id="facing-south" name="facing" value="south" onChange={handleInputChange} />
                        <label htmlFor="facing-south">South</label>
                        <input type="radio" id="facing-east" name="facing" value="east" onChange={handleInputChange} />
                        <label htmlFor="facing-east">East</label>
                        <input type="radio" id="facing-west" name="facing" value="west" onChange={handleInputChange} />
                        <label htmlFor="facing-west">West</label>
                    </div>

                    <div className="radio-group">
                        <label className="margin-top-10px-oms-div">Brokage</label>

                        <input
                            type="radio"
                            id="brokage-yes"
                            name="brokage"
                            value="yes"
                            onChange={handleInputChange}
                        />
                        <label htmlFor="brokage-yes">Yes</label>

                        <input
                            type="radio"
                            id="brokage-no"
                            name="brokage"
                            value="no"
                            onChange={handleInputChange}
                        />
                        <label htmlFor="brokage-no">No</label>
                    </div>
                    <div className='margin-top-10px-oms-div'>
                        <label>Parking</label>
                        <input type="text" name="parking" placeholder="Enter Number of Parking Slots" value={data.parking} onChange={handleInputChange} />
                    </div>
                    <div>
                        <label>Booking Amount(₹)</label>
                        <input type="text" name="securityDeposit" placeholder="Enter Booking Amount" value={data.securityDeposit} onChange={handleInputChange} />
                    </div>
                    <div className="location">
                        <div>
                            <label>Location Advantages</label>
                            <div className="button-group">
                                {locationAdvantages.map((advantage) => (
                                    <button
                                        type="button"
                                        key={advantage.id}
                                        className={`toggle-button ${selectedLocationAdvantages.includes(advantage.name)
                                            ? "selected"
                                            : ""
                                            }`}
                                        onClick={() => toggleLocationAdvantage(advantage.name)}
                                    >
                                        {advantage.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="location">
                        <div>
                            <label>Water Supply</label>
                            <div className="button-group">
                                {watersupply.map((advantage) => (
                                    <button
                                        type="button"
                                        key={advantage.id}
                                        className={`toggle-button ${selectedWaterSupply.includes(advantage.name)
                                            ? "selected"
                                            : ""
                                            }`}
                                        onClick={() => toggleWaterSupply(advantage.name)}
                                    >
                                        {advantage.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div className="location">
                        <div>
                            <label>Security</label>
                            <div className="button-group">
                                {security.map((advantage) => (
                                    <button
                                        type="button"
                                        key={advantage.id}
                                        className={`toggle-button ${selectedsecurity.includes(advantage.name)
                                            ? "selected"
                                            : ""
                                            }`}
                                        onClick={() => toggleSecurity(advantage.name)}
                                    >
                                        {advantage.name}
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                    <div>
                        <label>Virtual Tour (URL)</label>
                        <input type="text" name="virtualTour" placeholder="Enter Virtual Tour URL" value={data.virtualTour} onChange={handleInputChange} />
                    </div>
                    {/* <div className="radio-group">
                        <label>Property Category</label>
                        {
                            category.map((ele, idx) => (
                                <React.Fragment key={idx}>
                                    <input
                                        type="radio"
                                        id={`category-${ele.name}`}
                                        name="category"
                                        value={ele.name}
                                        onChange={handleInputChange}
                                    />
                                    <label htmlFor={`category-${ele.name}`}>{ele.name}</label>
                                </React.Fragment>
                            ))
                        }
                    </div> */}
                    <div className="margin-top-10px-oms-div">
                        <label>Developer Logo</label>
                        <input
                            type="file"
                            name="dev_logo"
                            accept="image/*"
                            onChange={handleInputChange}
                        />
                        {previews.dev_logo && (
                            <div className="image-preview">
                                <img
                                    src={previews.dev_logo}
                                    alt="Developer Logo Preview"
                                    style={{ maxWidth: "150px", marginTop: "10px" }}
                                />
                            </div>
                        )}
                        {errors.dev_logo && <span className="error">{errors.dev_logo}</span>}
                    </div>

                    <div>
                        <label>Developer Name</label>
                        <input
                            type="text"
                            name="developerName"
                            placeholder="Enter Developer Name"
                            value={data.developerName}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div>
                        <label>Developer Description</label>
                        <input
                            type='text'
                            name="developerDescription"
                            placeholder="Enter Developer Description"
                            value={data.developerDescription}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div>
                        <label>Property Description</label>
                        <input
                            type='text'
                            name="propertyDescription"
                            placeholder="Enter Property Description"
                            value={data.propertyDescription}
                            onChange={handleInputChange}
                        />
                    </div>

                    <div className="post-property-image">
                        <p className="post-property-image-head">Upload your image</p>
                        <p className="post-property-limits">
                            You can upload up to 20 images, with a total size limit of 20MB, in JPG or JPEG format.
                        </p>

                        <div
                            className={`post-property-image-container ${dragging ? 'dragging' : ''}`}
                            onDragOver={handleDragOver}
                            onDragLeave={handleDragLeave}
                            onDrop={handleDrop}
                        >
                            <i className="fa-solid fa-arrow-up-from-bracket"></i>
                            <p>Drag and drop your images or</p>
                            <button className="browse-files" onClick={handleBrowseClick}>
                                Browse images
                            </button>
                            <input
                                type="file"
                                ref={fileInputRef}
                                style={{ display: 'none' }}
                                multiple
                                accept=".jpg, .jpeg, .webp, .png"
                                onChange={handleFileChange}
                            />
                        </div>

                        <div className="upload-file-container">
                            {uploadedFiles.length > 0 ? (
                                <>
                                    <p className="upload-file-head">Uploaded Files:</p>

                                    <ul className="upload-file-list">
                                        {uploadedFiles.map((file, index) => {
                                            const tooLarge = file.size > 1024 * 1024;
                                            return (
                                                <li
                                                    key={index}
                                                    className={`upload-file-item ${tooLarge ? 'file-too-large' : ''}`}
                                                >
                                                    <span>{file.name} ({formatFileSize(file.size)})</span>
                                                    <button
                                                        className="delete-file-btn"
                                                        onClick={() => handleDeleteFile(index)}
                                                    >
                                                        <i className="fa-solid fa-xmark"></i>
                                                    </button>
                                                </li>
                                            );
                                        })}
                                    </ul>

                                    {/* Optional: Thumbnail previews */}
                                    <div className="image-gallery">
                                        {uploadedFiles.map((file, index) => (
                                            <div key={index} className="image-container">
                                                <img
                                                    src={URL.createObjectURL(file)}
                                                    alt={`Preview ${index + 1}`}
                                                    className="property-image"
                                                />
                                            </div>
                                        ))}
                                    </div>

                                    {uploadedFiles.some(file => file.size > 1024 * 1024) && (
                                        <p className="file-error-text">Remove files that exceed 1MB</p>
                                    )}
                                </>
                            ) : (
                                <p className="no-files-message">No files uploaded yet.</p>
                            )}
                        </div>
                    </div>
                    {
                        load ? <button type="submit" className='post-property-submit'>Submit</button> :
                            <button type="button" className='post-property-submit' disabled>Loading...</button>
                    }

                </form >
            </div >
        </>
    );
};

export default CommercialPropertyForm;